import { Injectable } from '@angular/core';

import { HttpClientService } from '../common/http-client.service';

@Injectable()
export class InvoiceService {
  private invoicesURL = 'invoices';
  private accountingInvoicesURL = 'accounting/invoices';

  constructor(private httpClient: HttpClientService) {}

  getInvoices(search_options: any): Promise<any> {
    search_options.get_invoices = true;
    return this.httpClient.get(`${this.invoicesURL}.json`, search_options);
  }

  getFormOptions(): Promise<any> {
    return this.httpClient.get(`${this.invoicesURL}.json`, { get_search_options: true });
  }

  getSearchOptions(): Promise<any> {
    return this.httpClient.get(`${this.invoicesURL}.json`, { get_search_options: true });
  }

  getInvoice() {}

  createInvoices(create_invoices_params: any): Promise<any> {
    return this.httpClient.get(`${this.invoicesURL}/new`, create_invoices_params);
  }

  withdrawInvoice(invoiceId: number): Promise<any> {
    return this.httpClient.post(`${this.invoicesURL}/${invoiceId}/withdraw.json`, {});
  }

  markInvoicePaid(invoiceId: number): Promise<any> {
    return this.httpClient.post(`${this.invoicesURL}/${invoiceId}/mark_paid.json`, {});
  }
}
